//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clone, chunk } from "lodash";
export default {
  props: {
    categories: {
      required: true,
    },
  },
  computed: {
    categoriesRows() {
      return chunk(clone(this.categories), 3);
    },
  },
};
